import React, {useContext} from "react";
import {injectIntl} from "react-intl";
import Modal from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import Text from "@amzn/meridian/text";
import {DraftContext} from "../../../draftSave/context/DraftSaveContext";
import {CONFIG_TYPE} from "../../../util/Constants";
import {getLocalizedMessage} from "../../../util/Localization";

const STATE_KEY = CONFIG_TYPE.RETRIEVER_LOCATION_MAPPING;

const DeleteRetrieverLocationMappingModal = ({intl, open, setOpen, selectedMac}) => {

    const {deleteAll} = useContext(DraftContext);

    const onConfirm = () => {
        deleteAll({stateKey: STATE_KEY, subKey: selectedMac});
        setOpen(false);
    };

    return (
        <Modal
            title={getLocalizedMessage({intl, stringId: "locationmapping.delete_title"})}
            open={open}
            onClose={() => setOpen(false)}
            scrollContainer="viewport"
            closeLabel="Close">
            <Column spacing="400">
                <Text>
                    {getLocalizedMessage({intl, stringId: "locationmapping.delete_confirmation"})}
                </Text>
                <Row spacing="300">
                    <Button type="primary" size="small" onClick={onConfirm}>
                        {getLocalizedMessage({intl, stringId: "modal.confirm"})}
                    </Button>
                    <Button type="secondary" size="small" onClick={() => setOpen(false)}>
                        {getLocalizedMessage({intl, stringId: "modal.cancel"})}
                    </Button>
                </Row>
            </Column>
        </Modal>
    );
};

export default injectIntl(DeleteRetrieverLocationMappingModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoretriever/modal/DeleteRetrieverLocationMappingModal.js